import { render } from "./NcrmContractDetails.vue?vue&type=template&id=fa4607bc&scoped=true"
import script from "./NcrmContractDetails.vue?vue&type=script&lang=js"
export * from "./NcrmContractDetails.vue?vue&type=script&lang=js"

import "./NcrmContractDetails.styles.css?vue&type=style&index=0&id=fa4607bc&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4607bc"]])

export default __exports__